// PCAI <pcai-chatbot> web component
const DEFAULT_PLUGIN_SRC = "https://dev-hyo-chatbot.powerconnect.ai/plugin.es.js";

class PcaiChatBot extends HTMLElement {
  static get observedAttributes() {
    return ["agent_id", "src"];
  }

  constructor() {
    super();
    this._initialized = false;
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    const agentId = this.getAttribute("agent_id") || "";
    const pluginSrc = this.getAttribute("src") || DEFAULT_PLUGIN_SRC;

    // Initialize window.config
    window.config = { ...(window.config || {}), agent_id: agentId };

    // Container expected by your plugin
    const container = document.createElement("div");
    container.id = "chat-bot"; // keep as-is for plugin compatibility
    this.appendChild(container);

    // Load the plugin script if not already loaded
    if (!window.__pcaiPluginLoaded) {
      window.__pcaiPluginLoaded = {};
    }
    if (!window.__pcaiPluginLoaded[pluginSrc]) {
      const script = document.createElement("script");
      script.type = "module";
      script.src = pluginSrc;
      script.crossOrigin = "anonymous";
      script.onerror = (e) => console.error("Failed to load PCAI plugin:", pluginSrc, e);
      document.head.appendChild(script);
      window.__pcaiPluginLoaded[pluginSrc] = true;
    }
  }

  attributeChangedCallback(name, oldVal, newVal) {
    if (!this._initialized || oldVal === newVal) return;
    if (name === "agent_id") {
      window.config = { ...(window.config || {}), agent_id: newVal || ""};
    }
  }
}

if (!customElements.get("pcai-chatbot")) {
  customElements.define("pcai-chatbot", PcaiChatBot);
}
